import { api } from '@/lib/api.js';

// Carrier admin API client (backend: routes/admin-carriers.routes.js).
// The browser uses the /api/tracon mount (broker JWT) so the activity_log
// actor is the broker email, not 'admin-api'. Carrier creation/deletion is
// SQL-only by policy — this service exposes read + update ONLY.

function qs(params = {}) {
  const u = new URLSearchParams();
  for (const [k, v] of Object.entries(params)) if (v != null && v !== '') u.set(k, v);
  u.set('_t', Date.now());
  return u.toString();
}

export function getCarriers() {
  return api.get(`/api/tracon/admin/carriers?${qs()}`);
}
export function getCarrier(slug) {
  return api.get(`/api/tracon/admin/carriers/${encodeURIComponent(slug)}?${qs()}`);
}
export function updateCarrier(slug, body) {
  return api.put(`/api/tracon/admin/carriers/${encodeURIComponent(slug)}`, body);
}
// Contact_Type filter is intentionally not passed by default — most CRM
// contacts have no Contact_Type tag, so a type filter returns zero matches
// (see the comment on the backend route).
export function searchCarrierCrmContacts(q, type) {
  return api.get(`/api/tracon/admin/carriers/_crm-contacts/search?${qs({ q, type })}`);
}
